const doc = window.document;
const getTextHeight = (text: string, styles: CSSStyleDeclaration) => {
  const tag = window.document.createElement('div');

  tag.innerText = text;

  Object.assign(tag.style, styles);

  doc.body.appendChild(tag);
  const { height: texHeight } = tag.getBoundingClientRect();
  if (doc.body.contains(tag)) {
    doc.body.removeChild(tag);
  }

  return texHeight;
};

/** Evaluates text overflow using width for single-line text and height otherwise. */
export const isTextEllipsized = (node: HTMLElement) => {
  const { width: nodeWidth, height: nodeHeight } = node.getBoundingClientRect();
  const computedNodeStyles = getComputedStyle(node);
  const whiteSpace = computedNodeStyles.whiteSpace;

  if (computedNodeStyles.overflow === 'visible') {
    return false;
  }

  // Nested content can add innerText newlines, so use width for single-line text.
  if (whiteSpace === 'nowrap') {
    return node.scrollWidth > node.clientWidth;
  }

  const title = node.innerText.replace(/\s+/g, ' ').trim();
  const styles: Partial<CSSStyleDeclaration> = {
    width: `${nodeWidth}px`,
    padding: computedNodeStyles.getPropertyValue('padding'),
    fontSize: computedNodeStyles.getPropertyValue('font-size'),
    fontFamily: computedNodeStyles.getPropertyValue('font-family'),
    fontWeight: computedNodeStyles.getPropertyValue('font-weight'),
    fontStyle: computedNodeStyles.getPropertyValue('font-style'),
    fontVariant: computedNodeStyles.getPropertyValue('font-variant'),
    lineHeight: computedNodeStyles.getPropertyValue('line-height'),
    wordBreak: 'break-all',
  };

  const textHeight = getTextHeight(title, styles as CSSStyleDeclaration);

  // The above calc is a rough estimate, so we allow for a 2px margin of error
  // (actual new line diffs would be >10px)
  return textHeight - nodeHeight > 2;
};
